// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default {
	page_title: "TEST",
	navbar_tab_1: "TEST",
	navbar_tab_2: "TEST",
	navbar_tab_3: "TEST",
	navbar_tab_4: "TEST",
	step: "TEST",
	you_accommodation: "TEST",
	adult: "TEST",
	Adult: "TEST",
	adults: "TEST",
	Adults: "TEST",
	child: "TEST",
	Child: "TEST",
	children: "TEST",
	Children: "TEST",
	age: "TEST",
	ages: "TEST",
	mister: "TEST",
	madam: "TEST",
	see_more: "TEST",
	see_less: "TEST",
	yes: "TEST",
	no: "TEST",
	see_more_options: "TEST",
	more_infos: "TEST",
	images_copyright: "TEST",
	day_monday: "TEST",
	day_tuesday: "TEST",
	day_wednesday: "TEST",
	day_thursday: "TEST",
	day_friday: "TEST",
	day_saturday: "TEST",
	day_sunday: "TEST",
	month_january: "TEST",
	month_february: "TEST",
	month_march: "TEST",
	month_april: "TEST",
	month_may: "TEST",
	month_june: "TEST",
	month_july: "TEST",
	month_august: "TEST",
	month_september: "TEST",
	month_october: "TEST",
	month_november: "TEST",
	month_december: "TEST",
	options_modify: "TEST",
	options_modify_panel: "TEST",
	options_panel_title_modify: "TEST",
	options_panel_title_modify_la: "TEST",
	options_panel_title_modify_for_1: "TEST",
	options_panel_title_modify_for_2: "TEST",
	options_add: "TEST",
	options_included: "TEST",
	options_day: "TEST",
	options_days: "TEST",
	options_days_2: "TEST",
	options_from: "TEST",
	options_to: "TEST",
	options_validate_selection: "TEST",
	validate_for_all_participants: "TEST",
	options_removed: "TEST",
	options_error_sorry: "TEST",
	options_error_default_service: "TEST",
	options_error_not_available: "TEST",
	options_no_service_selected: "TEST",
	options_no_service_selected_1: "TEST",
	options_no_service_selected_2: "TEST",
	options_no_skipass: "TEST",
	options_no_equipment: "TEST",
	options_no_transport: "TEST",
	options_no_esf: "TEST",
	options_no_food: "TEST",
	options_no_insurance_skier: "TEST",
	options_no_hotel_service: "TEST",
	options_15_cancellation: "TEST",
	options_45_cancellation: "TEST",
	options_45_cancellation_under_sentence: "TEST",
	options_who_departs: "TEST",
	options_please_fill_participants: "TEST",
	options_fill_names: "TEST",
	options_participant: "TEST",
	options_years: "TEST",
	options_years_and_more: "TEST",
	options_age_at_start: "TEST",
	options_first_name: "TEST",
	options_lastname: "TEST",
	options_travelers_error_message: "TEST",
	options_prepare_your_voyage: "TEST",
	options_select_your_insurances: "TEST",
	options_change_traveler_age: "TEST",
	options_change_traveler_age_confirmation: "TEST",
	options_change_traveler_age_updated: "TEST",
	options_I_understood: "TEST",
	options_skipass: "TEST",
	options_no_skipass_selected: "TEST",
	options_km_ski_slopes: "TEST",
	options_of_tracks: "TEST",
	options_remove_skipass_1: "TEST",
	options_remove_skipass_2: "TEST",
	options_no_queues: "TEST",
	options_skipass_blue_sentence: "TEST",
	options_equipment: "TEST",
	options_select_level: "TEST",
	criteria_997: "TEST",
	criteria_998: "TEST",
	criteria_999: "TEST",
	criteria_1000: "TEST",
	criteria_1031: "TEST",
	criteria_1030: "TEST",
	options_no_equipment_selected: "TEST",
	options_enjoy_skiing_at_arrival_1: "TEST",
	options_enjoy_skiing_at_arrival_2: "TEST",
	options_enjoy_skiing_at_arrival_3: "TEST",
	options_helmet: "TEST",
	options_shoes: "TEST",
	options_sticks: "TEST",
	options_equipment_blue_sentence: "TEST",
	options_transport: "TEST",
	options_enjoy_skiing_at_arrival: "TEST",
	options_distance_from_ski_shop_1: "TEST",
	options_distance_from_ski_shop_2: "TEST",
	options_distance_from_ski_shop_3: "TEST",
	options_distance_from_ski_shop_4: "TEST",
	options_add_transport: "TEST",
	options_add_transport_for: "TEST",
	options_delete_transport: "TEST",
	options_transport_first_date: "TEST",
	options_transport_second_date: "TEST",
	options_package_travelski: "TEST",
	options_train_plus_shuttle: "TEST",
	options_no_transport_selected: "TEST",
	options_choose_a_go: "TEST",
	options_choose_a_return: "TEST",
	options_departure_station: "TEST",
	options_arrival_station: "TEST",
	options_one_way_option: "TEST",
	options_i_travel_in: "TEST",
	options_my_transfer: "TEST",
	options_transport_summary_for: "TEST",
	options_total_transport: "TEST",
	options_transit_time: "TEST",
	options_estimated_time: "TEST",
	options_information: "TEST",
	train: "TEST",
	criteria_1039: "TEST",
	criteria_1040: "TEST",
	shuttle: "TEST",
	taxi: "TEST",
	baggage_cabin: "TEST",
	backpack: "TEST",
	wifi: "TEST",
	meal: "TEST",
	dinner: "TEST",
	options_how_to_choose_title: "TEST",
	options_ski_lesson: "TEST",
	options_take_esf: "TEST",
	options_course_on: "TEST",
	options_how_i_choose_lesson: "TEST",
	options_beginner: "TEST",
	options_piou_piou: "TEST",
	criteria_992: "TEST",
	criteria_993: "TEST",
	criteria_994: "TEST",
	criteria_995: "TEST",
	criteria_996: "TEST",
	options_no_course_selected: "TEST",
	options_content_piou_piou: "TEST",
	options_content_ourson_title: "TEST",
	options_content_ourson: "TEST",
	options_content_flocon_title: "TEST",
	options_content_flocon: "TEST",
	options_content_1_star_title: "TEST",
	options_content_1_star: "TEST",
	options_content_2_star_title: "TEST",
	options_content_2_star: "TEST",
	options_content_3_star_title: "TEST",
	options_content_3_star: "TEST",
	options_content_adulte_beginner_title: "TEST",
	options_content_adulte_beginner: "TEST",
	options_adults_beginner: "TEST",
	options_watch_video: "TEST",
	options_back_to_choices: "TEST",
	options_age_group_1: "TEST",
	options_age_group_2: "TEST",
	options_age_group_3: "TEST",
	options_age_group_4: "TEST",
	options_food: "TEST",
	options_take_food: "TEST",
	options_take_food_for: "TEST",
	options_catering: "TEST",
	options_catering_delivery: "TEST",
	options_no_food_selected: "TEST",
	options_see_menu: "TEST",
	options_restaurant: "TEST",
	options_catering_services: "TEST",
	options_facilitate_arrival: "TEST",
	options_reserve_your_services: "TEST",
	options_accommodation_services: "TEST",
	options_take_accommodation_services: "TEST",
	options_book_services: "TEST",
	options_book_services_easy: "TEST",
	options_insurance: "TEST",
	options_take_insurance: "TEST",
	options_no_insurance_selected: "TEST",
	options_insurance_advantages: "TEST",
	options_per_pers: "TEST",
	options_breakage_theft: "TEST",
	options_rescue_research: "TEST",
	options_hospitalization: "TEST",
	options_repatriation: "TEST",
	options_interruption_stay: "TEST",
	options_snow_guarantee: "TEST",
	options_insurance_annulation: "TEST",
	options_per_booking: "TEST",
	options_cancellation: "TEST",
	options_reimbursement: "TEST",
	options_credit_note: "TEST",
	options_coverage_price: "TEST",
	options_insurance_annulation_no: "TEST",
	options_insurance_annulation_yes: "TEST",
	options_insurance_slogan: "TEST",
	options_person: "TEST",
	options_free: "TEST",
	commercial_discount: "TEST",
	log_in_or_register: "TEST",
	login_register: "TEST",
	email_not_valid: "TEST",
	user_info_mandatory_field: "TEST",
	user_info_invalid_phone: "TEST",
	new_password_forgot_password: "TEST",
	new_password_create_new_password: "TEST",
	new_password1: "TEST",
	new_password2: "TEST",
	user_info_forgot_password: "TEST",
	user_info_already_have_account: "TEST",
	user_info_enter_email: "TEST",
	user_info_email_sent: "TEST",
	user_info_new_password: "TEST",
	send: "TEST",
	validate: "TEST",
	i_want_to_register: "TEST",
	i_want_to_login: "TEST",
	new_password_succes: "TEST",
	login: "TEST",
	registration_or_login: "TEST",
	save_booking: "TEST",
	user_info_your_informations: "TEST",
	contacts_first_name: "TEST",
	contacts_last_name: "TEST",
	contacts_email: "TEST",
	contacts_other_email: "TEST",
	contacts_password1: "TEST",
	contacts_password2: "TEST",
	contacts_password_format: "TEST",
	contacts_password_format_lenght: "TEST",
	contacts_password_format_lowercase: "TEST",
	contacts_password_format_uppercase: "TEST",
	contacts_password_format_number: "TEST",
	contacts_password_format_character: "TEST",
	contacts_passwords_dont_match: "TEST",
	contacts_email_is_not_valid: "TEST",
	user_info_to_contact_you: "TEST",
	contacts_address: "TEST",
	contacts_city: "TEST",
	contacts_country: "TEST",
	contacts_postal_code: "TEST",
	contacts_phone_number: "TEST",
	contacts_subscribe_newsletter: "TEST",
	opt_in_offers: "TEST",
	opt_in_quote: "TEST",
	opt_in_quote_payment: "TEST",
	personal_data_1: "TEST",
	personal_data_2: "TEST",
	personal_data_3: "TEST",
	contacts_accept_conditions_1: "TEST",
	contacts_accept_conditions_2: "TEST",
	contacts_accept_conditions_3: "TEST",
	contacts_accept_conditions_4: "TEST",
	update_my_details: "TEST",
	continue_with_these_contacts: "TEST",
	save_registration: "TEST",
	user_info_lihe_more_details: "TEST",
	user_info_create_account: "TEST",
	user_info_is_it_first_time: "TEST",
	error_wrong_email: "TEST",
	payment_my_account: "TEST",
	payment_choose_method: "TEST",
	proceed_to_payment: "TEST",
	payment_by_credit_card: "TEST",
	flex_product: "TEST",
	payment_credit_card_payment_condition_1_desc_1: "TEST",
	payment_credit_card_payment_condition_1_desc_2: "TEST",
	payment_credit_card_payment_condition_1_desc_3: "TEST",
	payment_credit_card_payment_condition_1_desc_4: "TEST",
	payment_credit_card_payment_condition_1_desc_5: "TEST",
	payment_credit_card_payment_condition_1_notice_1: "TEST",
	payment_credit_card_payment_condition_1_notice_1_2: "TEST",
	payment_credit_card_payment_condition_1_notice_2_2: "TEST",
	payment_credit_card_payment_condition_1_notice_2_3: "TEST",
	payment_credit_card_payment_condition_1_notice_2_4: "TEST",
	payment_credit_card_payment_condition_1_notice_2_5: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_1: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_2: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_3: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_4: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_5: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_1: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_2: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_3: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_4: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_5: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_1: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_2: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_3: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_4: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_5: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_6: "TEST",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_7: "TEST",
	payment_credit_card_payment_condition_1_notice_PV_after_deposit_1: "TEST",
	fix_product: "TEST",
	payment_credit_card_payment_condition_2_desc_1: "TEST",
	payment_credit_card_payment_condition_2_desc_2: "TEST",
	payment_credit_card_payment_condition_2_desc_3: "TEST",
	payment_credit_card_payment_condition_2_desc_4: "TEST",
	payment_credit_card_payment_condition_2_desc_5: "TEST",
	payment_credit_card_payment_condition_2_desc_6: "TEST",
	payment_credit_card_payment_condition_2_notice_1: "TEST",
	card_number: "TEST",
	credit_card_date: "TEST",
	cvc: "TEST",
	where_find_cvc: "TEST",
	cvc_popup_title: "TEST",
	cvc_popup_desc: "TEST",
	invalid_format: "TEST",
	invalid_card_detail: "TEST",
	pay_with_ideal: "TEST",
	pay_with_bancontact: "TEST",
	choose_bank: "TEST",
	payment_error_popup_title: "TEST",
	payment_error_popup_text: "TEST",
	confirmation_error_popup_phone: "TEST",
	payment_error_popup_button: "TEST",
	make_quote: "TEST",
	save_your_quote: "TEST",
	devis_desc_1: "TEST",
	devis_desc_2: "TEST",
	devis_desc_3: "TEST",
	devis_desc_4: "TEST",
	devis_desc_5: "TEST",
	save: "TEST",
	payment_status_check_payment: "TEST",
	payment_status_confirm_payment: "TEST",
	payment_status_check_availability: "TEST",
	summary_accommodation_details: "TEST",
	summary_package_total: "TEST",
	summary_thanks_to_pack_you_save: "TEST",
	summary_fee: "TEST",
	summary_fee_NL_SGRcontribution: "TEST",
	summary_fee_NL_Calamiteitenfonds: "TEST",
	summary_fee_WIYP: "TEST",
	summary_fee_NL_SGRcontribution_WIYP: "TEST",
	summary_fee_NL_Calamiteitenfonds_WIYP: "TEST",
	promocode: "TEST",
	promocode_wrong: "TEST",
	promocode_fnacdarty: "TEST",
	promocode_macif: "TEST",
	promocode_uneo: "TEST",
	promocode_first_name: "TEST",
	promocode_last_name: "TEST",
	promocode_last_6_digits: "TEST",
	promocode_date_of_birth: "TEST",
	promocode_date_of_birth_day: "TEST",
	promocode_date_of_birth_month: "TEST",
	promocode_date_of_birth_year: "TEST",
	promocode_mandatory_field: "TEST",
	promocode_invalid_format: "TEST",
	green_banner: "TEST",
	summary_enter_code: "TEST",
	summary_validate: "TEST",
	summary_total: "TEST",
	summary_book: "TEST",
	confirmation_status_reservation_title: "TEST",
	confirmation_status_reservation_subtitle_1: "TEST",
	confirmation_status_reservation_subtitle_2: "TEST",
	confirmation_reservation_1: "TEST",
	confirmation_reservation_2: "TEST",
	confirmation_reservation_3: "TEST",
	confirmation_reservation_4: "TEST",
	confirmation_reservation_5: "TEST",
	confirmation_reservation_6: "TEST",
	confirmation_reservation_7: "TEST",
	confirmation_reservation_8: "TEST",
	confirmation_reservation_9: "TEST",
	confirmation_reservation_10: "TEST",
	confirmation_by_phone: "TEST",
	confirmation_booking_100_percent_1: "TEST",
	confirmation_booking_100_percent_2: "TEST",
	confirmation_booking_100_percent_3: "TEST",
	confirmation_booking_100_percent_4: "TEST",
	confirmation_booking_100_percent_5: "TEST",
	confirmation_booking_100_percent_6: "TEST",
	confirmation_status_reservation_title_already_paid: "TEST",
	confirmation_status_quote_title: "TEST",
	confirmation_status_quote_subtitle: "TEST",
	confirmation_quote_1: "TEST",
	confirmation_quote_2: "TEST",
	confirmation_quote_3: "TEST",
	confirmation_reserve_quick: "TEST",
	go_back_to_booking: "TEST",
	confirmation_status_error_title: "TEST",
	confirmation_error_1: "TEST",
	confirmation_other_payment_method: "TEST",
	confirmation_error_1_sentence: "TEST",
	confirmation_unavailable_text: "TEST",
	confirmation_error_text: "TEST",
	confirmation_error_phone: "TEST",
	confirmation_make_reservation_account_title: "TEST",
	confirmation_make_reservation_account: "TEST",
	confirmation_make_reservation_account_button: "TEST",
	confirmation_make_reservation_phone_title: "TEST",
	confirmation_make_reservation_phone_1: "TEST",
	confirmation_make_reservation_phone_2: "TEST",
	confirmation_status_unavailable_title: "TEST",
	confirmation_status_unavailable_subtitle: "TEST",
	confirmation_unavailable_1: "TEST",
	confirmation_unavailable_2: "TEST",
	confirmation_find_another: "TEST",
	confirmation_find_another_same_title: "TEST",
	confirmation_find_another_same_1: "TEST",
	confirmation_find_another_same_button: "TEST",
	confirmation_find_another_other_title: "TEST",
	confirmation_find_another_other_1: "TEST",
	confirmation_find_another_other_button: "TEST",
	confirmation_find_another_search_title: "TEST",
	confirmation_find_another_search_1: "TEST",
	confirmation_find_another_search_2: "TEST",
	confirmation_find_another_search_button: "TEST",
	confirmation_find_another_question_title: "TEST",
	confirmation_find_another_question_1: "TEST",
	confirmation_your_order: "TEST",
	confirmation_summary_details_button: "TEST",
	confirmation_access_account: "TEST",
	tic_tac_trip_1: "TEST",
	tic_tac_trip_2: "TEST",
	tic_tac_trip_3: "TEST",
	tic_tac_trip_4: "TEST",
	tic_tac_trip_5: "TEST",
	tic_tac_trip_6: "TEST",
	tic_tac_trip_7: "TEST",
	Transport_private: "TEST",
	Transport_arrival: "TEST",
	Transport_return: "TEST",
	smile_and_pass: "TEST",
	Transport_coaches: "TEST",
	Transport_meal: "TEST",
	Transfer_private: "TEST",
	Transfer_bus: "TEST",
	snowboard_seul_argent_name: "TEST",
	snowboard_seul_argent_description: "TEST",
	snowboard_seul_or_name: "TEST",
	snowboard_seul_or_description: "TEST",
	pack_argent_snowboard_name: "TEST",
	pack_argent_snowboard_description: "TEST",
	pack_or_snowboard_name: "TEST",
	pack_or_snowboard_description: "TEST",
	skis_seuls_argent_name: "TEST",
	skis_seuls_argent_description: "TEST",
	skis_seuls_or_name: "TEST",
	skis_seuls_or_description: "TEST",
	skis_seuls_platine_name: "TEST",
	skis_seuls_platine_description: "TEST",
	pack_eco_name: "TEST",
	pack_eco_description: "TEST",
	pack_argent_name: "TEST",
	pack_argent_description: "TEST",
	pack_or_name: "TEST",
	pack_or_description: "TEST",
	pack_platine_name: "TEST",
	pack_platine_description: "TEST",
	pack_mini_kid_ski_name: "TEST",
	pack_mini_kid_ski_description: "TEST",
	pack_espoir_skis_name: "TEST",
	pack_espoir_skis_description: "TEST",
	pack_champion_skis_name: "TEST",
	pack_champion_skis_description: "TEST",
	pack_espoir_snowboard_name: "TEST",
	pack_espoir_snowboard_description: "TEST",
	pack_champion_snowboard_name: "TEST",
	pack_champion_snowboard_description: "TEST",
	panier_enfant_name: "TEST",
	panier_enfant_description: "TEST",
	panier_enfant_hallal_name: "TEST",
	panier_enfant_hallal_description: "TEST",
	panier_hallal_name: "TEST",
	panier_hallal_description: "TEST",
	panier_gourmand_name: "TEST",
	panier_gourmand_description: "TEST",
	panier_gastronomique_name: "TEST",
	panier_gastronomique_description: "TEST",
	global_insurance_conditions: "TEST",
	contacts_incorrect_credentials: "TEST",
	voir_le_detail_de_mon_trajet: "TEST",
	i_dont_want: "TEST",
	login_page_title: "TEST",
	accommodation_popup: "TEST",
	liheDesc_included: "TEST",
	planner_what_is_included: "TEST",
	productDesc_advantage: "TEST",
	planner_prestationsAppartmentEquipment: "TEST",
	planner_prestationsPrivateBathroom: "TEST",
	planner_prestationsPrivateKitchen: "TEST",
	planner_prestationsPrivateServices: "TEST",
	criteria_354: "TEST",
	criteria_353: "TEST",
	criteria_352: "TEST",
	criteria_351: "TEST",
	criteria_350: "TEST",
	criteria_349: "TEST",
	criteria_348: "TEST",
	criteria_347: "TEST",
	criteria_346: "TEST",
	criteria_345: "TEST",
	criteria_344: "TEST",
	criteria_343: "TEST",
	criteria_342: "TEST",
	criteria_341: "TEST",
	criteria_340: "TEST",
	criteria_339: "TEST",
	criteria_338: "TEST",
	criteria_337: "TEST",
	criteria_336: "TEST",
	criteria_335: "TEST",
	criteria_334: "TEST",
	criteria_333: "TEST",
	criteria_332: "TEST",
	criteria_331: "TEST",
	criteria_330: "TEST",
	criteria_329: "TEST",
	criteria_328: "TEST",
	criteria_327: "TEST",
	criteria_326: "TEST",
	criteria_325: "TEST",
	criteria_324: "TEST",
	criteria_323: "TEST",
	criteria_322: "TEST",
	criteria_321: "TEST",
	criteria_320: "TEST",
	criteria_319: "TEST",
	criteria_985: "TEST",
	criteria_982: "TEST",
	criteria_983: "TEST",
	criteria_762: "TEST",
	criteria_741: "TEST",
	criteria_987: "TEST",
	criteria_986: "TEST",
	criteria_988: "TEST",
	criteria_984: "TEST",
	criteria_767: "TEST",
	criteria_766: "TEST",
	criteria_765: "TEST",
	criteria_764: "TEST",
	criteria_763: "TEST",
	criteria_742: "TEST",
	criteria_769: "TEST",
	criteria_768: "TEST",
	criteria_743: "TEST",
	criteria_747: "TEST",
	criteria_771: "TEST",
	criteria_745: "TEST",
	criteria_744: "TEST",
	criteria_46: "TEST",
	criteria_746: "TEST",
	criteria_29: "TEST",
	criteria_773: "TEST",
	criteria_739: "TEST",
	criteria_738: "TEST",
	criteria_761: "TEST",
	criteria_30: "TEST",
	criteria_55: "TEST",
	criteria_27: "TEST",
	criteria_23: "TEST",
	criteria_803: "TEST",
	criteria_47: "TEST",
	criteria_799: "TEST",
	criteria_48: "TEST",
	criteria_25: "TEST",
	criteria_981: "TEST",
	criteria_31: "TEST",
	criteria_705: "TEST",
	criteria_757: "TEST",
	criteria_22: "TEST",
	criteria_756: "TEST",
	criteria_759: "TEST",
	criteria_750: "TEST",
	criteria_758: "TEST",
	criteria_752: "TEST",
	criteria_754: "TEST",
	criteria_755: "TEST",
	criteria_715: "TEST",
	criteria_714: "TEST",
	criteria_748: "TEST",
	criteria_45: "TEST",
	criteria_801: "TEST",
	criteria_51: "TEST",
	criteria_76: "TEST",
	criteria_75: "TEST",
	criteria_74: "TEST",
	criteria_74_76: "TEST",
	criteria_75_76: "TEST",
	criteria_71: "TEST",
	criteria_733: "TEST",
	criteria_69: "TEST",
	criteria_70: "TEST",
	criteria_732: "TEST",
	criteria_36: "TEST",
	criteria_37: "TEST",
	criteria_798: "TEST",
	criteria_979: "TEST",
	criteria_815: "TEST",
	criteria_52: "TEST",
	criteria_800: "TEST",
	criteria_980: "TEST",
	criteria_312: "TEST",
	criteria_807: "TEST",
	criteria_808: "TEST",
	criteria_306: "TEST",
	criteria_307: "TEST",
	criteria_308: "TEST",
	criteria_309: "TEST",
	criteria_310: "TEST",
	criteria_311: "TEST",
	criteria_365: "TEST",
	criteria_720: "TEST",
	criteria_721: "TEST",
	criteria_359: "TEST",
	criteria_360: "TEST",
	criteria_361: "TEST",
	criteria_362: "TEST",
	criteria_363: "TEST",
	criteria_364: "TEST",
	criteria_305: "TEST",
	criteria_718: "TEST",
	criteria_719: "TEST",
	criteria_299: "TEST",
	criteria_300: "TEST",
	criteria_301: "TEST",
	criteria_302: "TEST",
	criteria_303: "TEST",
	criteria_304: "TEST",
	criteria_291: "TEST",
	criteria_716: "TEST",
	criteria_717: "TEST",
	criteria_285: "TEST",
	criteria_822: "TEST",
	criteria_286: "TEST",
	criteria_287: "TEST",
	criteria_288: "TEST",
	criteria_289: "TEST",
	criteria_290: "TEST",
	criteria_60: "TEST",
	criteria_61: "TEST",
	criteria_62: "TEST",
	criteria_63: "TEST",
	criteria_64: "TEST",
	criteria_65: "TEST",
	criteria_67: "TEST",
	criteria_66: "TEST",
	criteria_700: "TEST",
	food_image_criteria_1025: "TEST",
	food_image_criteria_1025_mobile: "TEST",
	food_image_criteria_1024_1025: "TEST",
	food_image_criteria_1024_1025_mobile: "TEST",
	food_image_criteria_1023: "TEST",
	food_image_criteria_1023_mobile: "TEST",
	food_image_criteria_1024: "TEST",
	food_image_criteria_1024_mobile: "TEST",
	food_image_criteria_1023_1024: "TEST",
	food_image_criteria_1023_1024_mobile: "TEST",
	food_image_criteria_1021: "TEST",
	food_image_criteria_1021_mobile: "TEST",
	food_image_criteria_1067: "TEST",
	food_image_criteria_1067_mobile: "TEST",
	food_image_criteria_1069: "TEST",
	food_image_criteria_1069_mobile: "TEST",
	session_expired: "TEST",
	reload_page: "TEST"
    }
    